import { Section, Row, KeyValueList, toTitle } from './ReportUIPrimitives';
import styles from './GenericViewer.module.css';

const GenericViewer = ({ data = {}, title = "Report Details" }) => {
  const { summary, collection_name, ...rest } = data;

  return (
    <div className={styles.container}>
      {summary && (
        <div className={styles.summaryCard}>
          <h4 className={styles.summaryTitle}>Summary</h4>
          <p className={styles.summaryText}>{summary}</p>
        </div>
      )}

      <Section title="Details">
        <KeyValueList obj={rest} />
      </Section>
    </div>
  );
};

export default GenericViewer;
